export default __webpack_public_path__ + "static/media/finale_banner.e365f26c.jpg";